import request from './http';
import qs from 'qs';
/**
 * 行业最近数据
 * @returns 行业最近数据
 */
export const getSacInfo = function (current) {
  return request.post("/sacinfo/stdQueryList", {
    current: current || 1,
    size: 80,
    key: '',
    ministry: '',
    industry: '',
    pubdate: -1,
    date: '',
    status: "现行"
  }, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    transformRequest: [function (data) {
      // 对发送的 data 进行任意转换处理
      return qs.stringify(data);
    }],
  });
}

export const leaveMessages = function (current) {
  return request.post("/bzw/leaveMessages/create", current);
}